module.exports = __webpack_public_path__ + "static/media/gpay.f660a637.png";